export default {
  "redemptionCodeConfig.title": "兑换码配置",
  "redemptionCodeConfig.column.no": "#序号",
  "redemptionCodeConfig.column.redemptionCode": "兑换码",
  "redemptionCodeConfig.column.channel": "渠道",
  "redemptionCodeConfig.column.amount": "金额",
  "redemptionCodeConfig.column.withdrawLimit": "提现限制",
  "redemptionCodeConfig.column.enable": "启用",
  "redemptionCodeConfig.column.createTime": "创建时间",
  "redemptionCodeConfig.column.status": "状态",
  "redemptionCodeConfig.search.disable": "禁用",
  "redemptionCodeConfig.column.action": "操作",
  "redemptionCodeConfig.action.details": "详情",
  "redemptionCodeConfig.action.edit": "编辑",
  "redemptionCodeConfig.action.enable": "启用",
  "redemptionCodeConfig.action.disable": "禁用",
  "redemptionCodeConfig.search.redemptionCode": "兑换码",
  "redemptionCodeConfig.search.channel": "渠道",
  "redemptionCodeConfig.search.enable": "启用",
  "redemptionCodeConfig.form.redemptionCode": "兑换码",
  "redemptionCodeConfig.form.amount": "金额",
  "redemptionCodeConfig.form.withdrawLimit": "提现限制",
  "redemptionCodeConfig.form.channel": "渠道",
  "redemptionCodeConfig.confirm.enable.title": "启用兑换码: {redemptionCode}",
  "redemptionCodeConfig.confirm.disable.title": "禁用兑换码: {redemptionCode}",
  "redemptionCodeConfig.confirm.enable.content": "确定要启用此兑换码吗？",
  "redemptionCodeConfig.confirm.disable.content": "确定要禁用此兑换码吗？",
  "redemptionCodeConfig.confirm.ok": "确认",
  "redemptionCodeConfig.confirm.cancel": "取消",
  "redemptionCodeConfig.add": "新增",
  "redemptionCodeConfig.edit": "编辑",
  "redemptionCodeConfig.details": "详情",
};